import Transformer from '../transformer'
import AffectedTransformer from './AffectedTransformer'

import { shortDate, money, fromNowDate, timeBetween2Dates } from '@/filters'

/**
 * @author Andrés Aguilar <andresyoshimar@gmail.com>
 */

export default class PackageTransformer extends Transformer {
  static fetch(pkg) {
    return {
      addDate: shortDate(pkg.add_date),
      folio: pkg.folio,
      validationDate: pkg.validation_date !== null ? shortDate(pkg.validation_date) : fromNowDate(pkg.add_date),
      validationTime: pkg.validation_date !== null ? timeBetween2Dates(pkg.add_date, pkg.validation_date) : 'false',
      ...pkg.status,
      relatedAffected: AffectedTransformer.fetchCollection(pkg.related_affected),
      sinisters: pkg.related_affected.length,
      dollarPrice: Number(pkg.exchange_price),
      total: money(pkg.total),
      totalUSD: money(Number(pkg.total) / Number(pkg.exchange_price)),
      totalPayments: money(pkg.total_paid),
      id: pkg.id,
    }
  }
  static send(pkg) {}
}


// WEBPACK FOOTER //
// ./src/transformers/extranet/PackageTransformer.js